export const functionCloserToString = (orgId: string, baseUrl: string, protocol: string) => {
  return (
    "<script id='closer-widget-script'>" +
    `
    (function (c, l, o, s, e, r) {
        c.closer = c.closer || { q: [] };
        ["init", "identify", "openWidget"].forEach(function (m) {
            c.closer[m] = function () {
                this.q.push({ method: m, args: arguments });
                }
            });
        c.closer["scriptUrl"] = s;
        e = l.createElement(o);
        e.async = 1;
        e.src = s;
        r = l.getElementsByTagName(o)[0];
        r.parentNode.insertBefore(e, r);
    })(window, document, "script", "${protocol}://widget.${baseUrl}/widget.js");

    closer.init({
        orgId: "${orgId}",
    });
    closer.identify();
` +
    "</script>"
  );
};
